







import { mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { defineComponentTranslations } from '~/utils/i18n'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, [
      'sellerIsBlacklistedSuspiciousOrFraudster'
    ])
  },
  i18n: defineComponentTranslations({
    do_not_send_money: {
      en: 'Do not send money or you will lose it',
      el: 'Μην στέλνετε χρήματα θα τα χάσετε'
    }
  })
})
